import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import { CompanyCommunityGuard, TenantCommunityGuard } from '@src/components/guard/CommunityGuard';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CommunityMemberListForm from '@src/features/shared/community/CommunityMemberListForm';
import CommunityDefaultLayout from '@src/layouts/shared/CommunityDefaultLayout';

function CommunityMembers() {
  const tenantAuth = useTenantAuth();
  if (!tenantAuth.profile) {
    return null;
  }
  const isAdmin = !!tenantAuth.profile?.user?.isAdmin;
  return (
    <>
      {tenantAuth.profile?.isLogin ? (
        <TenantCommunityGuard
          canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT, TENANT_ROLE.MEMBER]}
          canService={[SERVICE.ONLINE_COMMUNITY]}
          checkAuthenticate={true}
          checkAccessibleNotPublicChannel={!isAdmin}
        >
          <CommunityDefaultLayout>
            <CommonHelmet />
            <CommunityMemberListForm />
          </CommunityDefaultLayout>
        </TenantCommunityGuard>
      ) : (
        <CompanyCommunityGuard
          canRoles={[COMPANY_ROLE.ADMIN, COMPANY_ROLE.USER]}
          canService={[SERVICE.ONLINE_COMMUNITY]}
          checkAuthenticate={true}
          checkAccessibleNotPublicChannel={true}
        >
          <CommunityDefaultLayout>
            <CommonHelmet />
            <CommunityMemberListForm />
          </CommunityDefaultLayout>
        </CompanyCommunityGuard>
      )}
    </>
  );
}

export default CommunityMembers;
